import React from 'react';

interface AddApplicationButtonProps {
  onClick: () => void;
}

export const AddApplicationButton: React.FC<AddApplicationButtonProps> = ({ onClick }) => {
  return (
    <button
    onClick={onClick}
    className="flex items-center border border-gray-200 rounded-md px-3 py-2 text-sm font-medium text-gray-900 bg-gray-200 hover:bg-gray-300 "
>
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
    </svg>
    Add New Application
</button>
    );
};